(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-chat-launcher"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cm-chat-launcher')){
    customElements.define('cm-chat-launcher',class extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.controller=new AbortController();
        const options={signal:this.controller.signal};
        this.launch=this.querySelector('.cm-chat-launch');
        this.panel=this.querySelector('.cm-chat-panel');
        this.hidden=false;
        this.launch.addEventListener('click',()=>this.toggle(this.panel.hidden),options);
        this.querySelector('[data-close]').addEventListener('click',()=>{this.toggle(false);this.launch.focus()},options);
        document.addEventListener('click',e=>{if(!this.contains(e.target))this.toggle(false)},options);
        document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!this.panel.hidden){this.toggle(false);this.launch.focus()}},options);
        this.querySelector('[data-online]').addEventListener('click',e=>{
          e.stopPropagation();
          this.connectInbox();
          if(!this.activator){this.querySelector('[data-error]').hidden=false;return}
          this.toggle(false);
          document.querySelector('shopify-chat')?.setAttribute('open','');
        },options);
        this.connectInbox();
        let attempts=0;
        this.timer=setInterval(()=>{this.connectInbox();if(this.activator||++attempts>=60)clearInterval(this.timer)},500);
      }
      toggle(open){this.panel.hidden=!open;this.launch.setAttribute('aria-expanded',String(open))}
      connectInbox(){
        const host=document.querySelector('shopify-chat');
        const root=host?.shadowRoot;
        const button=root?.querySelector('button[part="activator"]')||root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part="activator"]');
        if(!button||button===this.activator)return;
        this.observer?.disconnect();
        this.activator=button;
        document.documentElement.classList.add('cm-chat-ready');
        const sync=()=>{const wasHidden=this.hidden;this.hidden=host.hasAttribute('open')||button.getAttribute('aria-expanded')==='true';if(wasHidden&&!this.hidden)this.launch.focus()};
        this.observer=new MutationObserver(sync);
        this.observer.observe(button,{attributes:true,attributeFilter:['aria-expanded']});
        this.observer.observe(host,{attributes:true,attributeFilter:['open']});
        sync();
      }
      disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;document.documentElement.classList.remove('cm-chat-ready')}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
